!function (n, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : n.dayjs_plugin_customParseFormat = t();
}(this, function () {
  "use strict";

  var n,
      t = /(\[[^[]*\])|([-:/.()\s]+)|(A|a|YYYY|YY?|MM?M?M?|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,
      e = /\d\d/,
      r = /\d\d?/,
      o = /\d*[^\s\d]+/;

  var s = function s(n) {
    return function (t) {
      this[n] = +t;
    };
  },
      i = [/[+-]\d\d:?\d\d/, function (n) {
    var t, e;
    (this.zone || (this.zone = {})).offset = (t = n.match(/([+-]|\d\d)/g), 0 === (e = 60 * t[1] + +t[2]) ? 0 : "+" === t[0] ? -e : e);
  }],
      a = {
    A: [/[AP]M/, function (n) {
      this.afternoon = "PM" === n;
    }],
    a: [/[ap]m/, function (n) {
      this.afternoon = "pm" === n;
    }],
    S: [/\d/, function (n) {
      this.milliseconds = 100 * +n;
    }],
    SS: [e, function (n) {
      this.milliseconds = 10 * +n;
    }],
    SSS: [/\d{3}/, function (n) {
      this.milliseconds = +n;
    }],
    s: [r, s("seconds")],
    ss: [e, s("seconds")],
    m: [r, s("minutes")],
    mm: [e, s("minutes")],
    H: [r, s("hours")],
    h: [r, s("hours")],
    HH: [e, s("hours")],
    hh: [e, s("hours")],
    D: [r, s("day")],
    DD: [e, s("day")],
    M: [r, s("month")],
    MM: [e, s("month")],
    MMM: [o, function (t) {
      var e = n,
          r = e.months,
          o = e.monthsShort,
          s = o ? o.findIndex(function (n) {
        return n === t;
      }) : r.findIndex(function (n) {
        return n.substr(0, 3) === t;
      });
      if (s < 0) throw new Error();
      this.month = s + 1;
    }],
    MMMM: [o, function (t) {
      var e = n.months.indexOf(t);
      if (e < 0) throw new Error();
      this.month = e + 1;
    }],
    Y: [/[+-]?\d+/, s("year")],
    YY: [e, function (n) {
      n = +n, this.year = n + (n > 68 ? 1900 : 2e3);
    }],
    YYYY: [/\d{4}/, s("year")],
    Z: i,
    ZZ: i
  };

  var u = function u(n, e) {
    try {
      var r = function (n) {
        for (var e = n.match(t), r = e.length, o = 0; o < r; o += 1) {
          var s = e[o],
              i = a[s],
              u = i && i[0],
              f = i && i[1];
          e[o] = f ? {
            regex: u,
            parser: f
          } : s.replace(/^\[|\]$/g, "");
        }

        return function (n) {
          for (var t = {}, o = 0, s = 0; o < r; o += 1) {
            var i = e[o];
            if ("string" == typeof i) s += i.length;else {
              var a = i.regex,
                  u = i.parser,
                  f = n.substr(s),
                  h = a.exec(f)[0];
              u.call(t, h), s += h.length;
            }
          }

          return function (n) {
            var t = n.afternoon;

            if (void 0 !== t) {
              var e = n.hours;
              t ? e < 12 && (n.hours += 12) : 12 === e && (n.hours = 0), delete n.afternoon;
            }
          }(t), t;
        };
      }(e)(n),
          o = r.year,
          s = r.month,
          i = r.day,
          u = r.hours,
          f = r.minutes,
          h = r.seconds,
          d = r.milliseconds,
          c = r.zone;

      if (c) return new Date(Date.UTC(o, s - 1, i, u || 0, f || 0, h || 0, d || 0) + 60 * c.offset * 1e3);
      var m = new Date();
      return new Date(o || m.getFullYear(), s > 0 ? s - 1 : m.getMonth(), i || m.getDate(), u || 0, f || 0, h || 0, d || 0);
    } catch (n) {
      return new Date("");
    }
  };

  return function (t, e, r) {
    var o = e.prototype,
        s = o.parse;

    o.parse = function (t) {
      var e = t.date,
          o = t.format,
          i = t.pl;
      o ? (n = i ? r.Ls[i] : this.$locale(), this.$d = u(e, o), this.init(t)) : s.call(this, t);
    };
  };
});